import { ActionContext } from "vuex";
import { LoggerService as lgg } from "vue-components-library";

import { TrucksService } from "@/Trucks/services";

const LOG_TAG = "[TRUCKS STORE]";

function getDefaultState() {
  return {
    data: [],
    selectedItem: null
  };
}

const state = getDefaultState();

const getters = {
  data: (state: any) => state.data,
  selectedItem: (state: any) => state.selectedItem,
  totalItems: (state: any) => state.data.length,
  thisItem: (state: any) => {
    if (!state.selectedItem) {
      return null;
    }
    return state.data.filter((item: any) => item.id === state.selectedItem)[0];
  }
};

export const actions = {
  selectItem(context: ActionContext<any, any>, id: String) {
    context.commit("SELECT_ITEM", id);
  },
  async loadData(context: ActionContext<any, any>, emsAgencyId: String) {
    try {
      context.dispatch("Global/loading", null, { root: true });
      const trucks = (await TrucksService.getData(emsAgencyId)).map(truck => {
        truck.type = truck.isALS ? "ALS" : "BLS";
        return truck;
      });
      context.commit("SET_DATA", trucks);
      context.dispatch("Global/doneLoading", null, { root: true });
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to fetch Trucks`, { error });
    }
  },
  async insertData(context: ActionContext<any, any>, payload: any) {
    try {
      const { emsAgencyId, body } = payload;
      context.dispatch("Global/loading", null, { root: true });
      await TrucksService.insertData(emsAgencyId, body);
      context.dispatch("Global/doneLoading", null, { root: true });
      context.dispatch("loadData", emsAgencyId);
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to create Truck`, { error });
    }
  },
  async updateData(context: ActionContext<any, any>, payload: any) {
    try {
      const { emsAgencyId, recordId, body } = payload;
      context.dispatch("Global/loading", null, { root: true });
      await TrucksService.updateData(emsAgencyId, recordId, body);
      context.dispatch("Global/doneLoading", null, { root: true });
      context.dispatch("loadData", emsAgencyId);
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to update Truck`, { error });
    }
  },
  refresh(context: ActionContext<any, any>, emsAgencyId: String) {
    context.dispatch("loadData", emsAgencyId);
  }
};

const mutations = {
  SET_DATA(state: any, data: any) {
    state.data = data;
  },
  SELECT_ITEM(state: any, id: String) {
    state.selectedItem = state.selectedItem === id ? null : id;
  }
};

const store: any = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default store;
